import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';

const VALIDATION = {
  annualGoal: [
    validatePresence({ presence: true, message: "Can't be blank" }),
    validateNumber({ gte: 1, message: 'Must be a positive number' }),
  ],
  startAtMonth: [
    validatePresence({ presence: true, message: "Can't be blank" }),
    validateNumber({ gte: 0, lte: 12, message: 'Must be a number ' }),
  ],
};

export default Route.extend({
  fundsService: service(),
  abilities: service(),
  navbarSettings: service(),
  settings: service(),
  store: service(),

  isAnnualRollingGoal: alias('settings.userSettings.showAnnualGoal'),

  beforeModel(transition) {
    if (this.abilities.noAbility('edit_goal')) {
      transition.abort();
    }
    return this.fundsService.confirmValidFundToken();
  },

  async model() {
    let record = (await this.store.query('ytd-fund-goal', {})).slice()[0];
    if (record) {
      set(this, 'navbarSettings.title', 'Edit Annual Goal');
    } else {
      set(this, 'navbarSettings.title', 'Add Annual Goal');
      record = this.store.createRecord('ytd-fund-goal');
    }
    let changeset = Changeset(
      record,
      lookupValidator(VALIDATION),
      VALIDATION,
    );
    let defaultStartAtMonth = this.settings.orgSettings.ytdStartAtMonth;
    if (defaultStartAtMonth) {
      set(changeset, 'startAtMonth', defaultStartAtMonth);
    }
    return {
      record,
      changeset,
      defaultStartAtMonth,
    };
  }
});
